import { ExerciseOption } from '@/types';

export const EXERCISE_OPTIONS: ExerciseOption[] = [
  { id: 'pushups', name: 'Push-ups', icon: '💪', unit: 'reps' },
  { id: 'pullups', name: 'Pull-ups', icon: '🏋️', unit: 'reps' },
  { id: 'squats', name: 'Squats', icon: '🦵', unit: 'reps' },
  { id: 'crunches', name: 'Crunches', icon: '🔥', unit: 'reps' },
  { id: 'custom', name: 'Custom Exercise', icon: '➕', unit: 'reps' },
];

export const UNIT_TYPES = [
  { id: 'reps', name: 'Reps', increments: [1, 5, 10] },
  { id: 'meters', name: 'Meters', increments: [10, 50, 100] },
  { id: 'kilograms', name: 'Kilograms', increments: [1, 5, 10] },
  { id: 'minutes', name: 'Minutes', increments: [0.5, 1, 5] },
];

export const EXERCISE_ICONS = [
  '🏃',
  '🚴',
  '🏊',
  '🏋️',
  '🤸',
  '🧘',
  '⛹️',
  '🥊',
  '🤾',
  '🏐',
  '⚽',
  '🏸',
  '🎾',
  '🏓',
];

// Arnold Schwarzenegger motivational quotes organized by progress
export const MOTIVATIONAL_QUOTES = {
  start: [
    'Come on! Start the reactor!',
    "It's not a tumor... it's your muscles growing!",
    'You are not machines! You are not cattle! You are men!',
  ],
  low: [
    'I can feel it... the pump!',
    'More weight! Get serious!',
    'Go the distance, champ!',
    'Feel the burn!',
  ],
  medium: [
    "You're one ugly mother... But strong!",
    'Dillon! You son of a bitch!',
    'If it bleeds, we can kill it!',
  ],
  high: [
    "Get to the chopper! You're crushing it!",
    'I am a machine! Keep going!',
    "You're terminated... today's target!",
  ],
  complete: [
    'HASTA LA VISTA, BABY!',
    'You are a champion! Now... party!',
    "I'll be back... for more challenges!",
  ],
};

export const WHEEL_INCREMENTS = {
  reps: [-10, -5, -1, 1, 5, 10],
  meters: [-100, -50, -10, 10, 50, 100],
  kilograms: [-10, -5, -1, 1, 5, 10],
  minutes: [-5, -1, -0.5, 0.5, 1, 5],
};

export const CONFIG = {
  isDevelopment: import.meta.env.DEV,
  apiUrl:
    import.meta.env.VITE_API_URL ||
    (import.meta.env.DEV
      ? 'http://localhost:8787'
      : 'https://pushing-pencils.steve-89f.workers.dev'),
  offlineTimeout: 30000,
  syncRetryAttempts: 3,
  syncRetryDelay: 1000,
  maxDailyLogs: 1000,
  maxChallengeParticipants: 100,
  wheelMaxValue: 200,
  version: '1.0.0',
};

export const STORAGE_KEYS = {
  user: 'fitness_user',
  challenges: 'fitness_challenges',
  exerciseLogs: 'fitness_exercise_logs',
  syncQueue: 'fitness_sync_queue',
  lastSync: 'fitness_last_sync',
};

export const API_ENDPOINTS = {
  auth: '/api/auth',
  challenges: '/api/challenges',
  activity: '/api/activity',
  participants: '/api/participants',
  users: '/api/users',
};

export const ERROR_MESSAGES = {
  offline: 'You are currently offline. Changes will sync when connection is restored.',
  syncFailed: 'Failed to sync data. Will retry automatically.',
  challengeNotFound: 'Challenge not found. Please check the ID and try again.',
  userNotFound: 'User not found. Please log in again.',
  networkError: 'Network error. Please check your connection.',
  validationError: 'Invalid data. Please check your input.',
  serverError: 'Server error. Please try again later.',
  unauthorized: 'Unauthorized. Please log in again.',
};
